import useUser from 'hooks/useAuth';
import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { adminArea, menuItems, menuItemsProps } from 'utils';

type MenuDropdownProps = {
  setIsOpen: (data: boolean) => void;
};
interface rightSideMenu extends menuItemsProps {
  choice: boolean;
  disabled: boolean;
  image: string;
}
const MenuDropdown = ({ setIsOpen }: MenuDropdownProps) => {
  const { user } = useUser();
  const [show, setShow] = useState<boolean>(false);
  const [rightSide, setRightSide] = useState<menuItemsProps[]>([]);
  const navigate = useNavigate();

  const choice = (item: menuItemsProps[] | menuItemsProps, click: string) => {
    if (click === 'admin-area') {
      setShow(true);
      setRightSide(item as menuItemsProps[]);
    } else {
      setShow(true);
      if (user?.role === 'admin' || user?.role === 'department_manager' || user?.role === "service_manager") {
        const t = [];

        t.push(
          menuItems.find((o) => o.title === (item as menuItemsProps).title),
        );

        setRightSide(t as rightSideMenu[]);
      } else {
        const t = [];
        t.push(
          menuItems.find((o) => o.title === (item as menuItemsProps).title),
        );
        const employeeList = t[0]?.items?.filter(
          (item) => item.title !== 'Request approval',
        );
        Object.assign(t[0], { items: employeeList });
        setRightSide(t as rightSideMenu[]);
      }
    }
  };

  return (
    <div
      style={{ height: user?.role === 'admin' ? 470 : 420, marginTop: '17px', marginLeft: '-16px' }}
      className="layout_header_update_menu_dropdown"
    >
      <div className="layout_header_update_menu_dropdown_left_side">
        <div className="layout_header_update_menu_dropdown_left_side_header">
          <span
            style={{ fontWeight: 600, fontSize: '14px', color: '#000', lineHeight: '16px' }}
          >
            Menu
          </span>
          <img
            onClick={() => setIsOpen(false)}
            src="/icons/close.svg"
            alt="close-icon"
            height={20}
            width={20}
            style={{ cursor: 'pointer' }}
          />
        </div>
        <div className="layout_header_update_menu_dropdown_left_side_body">
          {menuItems.map((item: any, index: number) => (
            <div
              style={item.disabled ? { opacity: '0.5' } : {}}
              onClick={() => !item.disabled && choice(item, item.title)}
              key={index}
              className="layout_header_update_menu_dropdown_left_side_body_items"
            >
              <img width={32} height={32} src={item.image} alt="images" />
              <span
                style={{ marginTop: '10px', fontWeight: 600, fontSize: '12px', color: '#000' }}
              >
                {item.label}
              </span>
            </div>
          ))}
        </div>
        {user?.role === 'admin' && (
          <div className="layout_header_update_menu_dropdown_left_side_footer">
            <div
              onClick={() => choice(adminArea, 'admin-area')}
              className="layout_header_update_menu_dropdown_left_side_footer_admin"
            >
              <img
                width={32}
                height={32}
                src="/icons/admin_settings.svg"
                alt="settings"
              />
              <span
                style={{
                  fontWeight: 600,
                  fontSize: '12px',
                  lineHeight: '10px',
                  color: '#000'
                }}
              >
                ADMIN AREA{' '}
              </span>
            </div>
          </div>
        )}
      </div>
      {show &&
        rightSide?.map((o: any, index: number) => (
          <div
            key={index}
            className="layout_header_update_menu_dropdown_right_side"
          >
            <div className="layout_header_update_menu_dropdown_right_side_header">
              <span
                style={{
                  fontWeight: 600,
                  fontSize: '14px',
                  lineHeight: '16px',
                  color: '#000'
                }}
              >
                {o.title}
              </span>
            </div>
            <div>
              {o?.items.map((item: any, index: number) => (
                <button
                  disabled={item.title === "Time & Activities"}
                  onClick={() => {
                    navigate(item.route);
                    setIsOpen(false);
                  }}
                  style={
                    item.disabled
                      ? {
                        color: 'gray',
                        background: 'white',
                        fontWeight: 400,
                      }
                      : {}
                  }
                  className="layout_header_update_menu_dropdown_right_side_items"
                  key={index}
                >
                  <div
                    style={{
                      width: '100%',
                      display: 'flex',
                      justifyContent: 'space-between',
                      paddingRight: '16px',
                      color: '#000',
                      fontWeight: '600px',
                      fontSize: '12px',
                      opacity: item.title === "Time & Activities" && '0.5'
                    }}
                  >
                    {item.title}
                    <img src="/icons/rotate_button.svg" alt="next" />
                  </div>
                </button>
              ))}
            </div>
          </div>
        ))}
    </div>
  );
};

export default MenuDropdown;
